export const timezoneOptions = [
    {label: '5', value:5},
    {label: '6', value:6}
];

